import { ArrowRight, Filter, Search, Calendar, List, Grid, Plus, X } from "react-feather";
import { FormControl, InputLabel, Select, MenuItem, TextField, IconButton, Button } from "@mui/material";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../prospectListView.module.css";
import NumberFormat from "react-number-format";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import React from "react";

const CreditScoreField = React.forwardRef((props, ref) => {
  return (<NumberFormat
    customInput={TextField}
    prefix=""
    displayType="input"
    format={"###"}
    {...props}
  />);
});

const MoneyField = React.forwardRef((props, ref) => {
  return (<NumberFormat
    customInput={TextField}
    prefix=""
    displayType="input"
    type="text"
    thousandSeparator={true}
    allowNegative={false}
    decimalScale={0}
    {...props}
  />);
});

const schema1 = yup.object().shape({
  min: yup.string().required("This field is Required"),
  max: yup.string().required("This field is Required"),
});

const schema2 = yup.object().shape({
  min: yup.string().required("This field is Required"),
  max: yup.string().required("This field is Required"),
});

const ListFilters = ({ setFilterData, setFilterOpen, filterOpen, filterData, propertyList, handleView, setCurrentFilterValue, setOpenAddProspectModal, setAddFormStep, isAuthenticated, setCreditFilterData, setCreditFilterOpen, setAddCustomCredit, onSubmitCreditFiler, addCustomCredit, creditFilterData, setCreditFilterDefaultOpen, creditFilterOpen, user, setSalaryFilterData, setSalaryFilterOpen, salaryFilterOpen, setAddCustomSalary, onSubmitSalaryFiler, addCustomSalary, salaryFilterData, setSalaryFilterDefaultOpen, setSearchKey }) => {

  const { handleSubmit: handleSubmit1, control: control1 } = useForm({
    resolver: yupResolver(schema1),
  });

  const { handleSubmit: handleSubmit2, control: control2 } = useForm({
    resolver: yupResolver(schema2),
  });

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => {
          const handler = setTimeout(() => {
            setSearchKey(e.target.value);
            setCurrentFilterValue("search");
          }, 1000);

          return () => {
            clearTimeout(handler);
          }
        }} />
      </div>
      <div className={`${styles.ListGridBUCard} ${styles.Top}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("list")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>

      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button className={`${styles.AddNoteBu} ${styles.Top}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
        <Plus /> <span>Prospect</span>
      </button>)}
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters{" "}
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Property</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Property"
              value={filterData?.property}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, property: e.target.value };
                });
                setCurrentFilterValue("property");
              }}
            >
              {propertyList?.map((i) => {
                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Prospects</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Prospects"
              value={filterData?.prospect}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, prospect: e.target.value };
                });
                setCurrentFilterValue("prospect");
              }}
            >
              <MenuItem value="all">All Prospects</MenuItem>
              <MenuItem value="applied">Applied</MenuItem>
              <MenuItem value="not_applied">Not Applied</MenuItem>
              <MenuItem value="screened">Screened</MenuItem>
              <MenuItem value="approved">Approved</MenuItem>
              <MenuItem value="declined">Declined</MenuItem>
              <MenuItem value="archived">Archived</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, submitted_at: date };
                });
                setCurrentFilterValue("submitted_at");
              }}
            />
          </div>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter CloseFilter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Filter by Credit</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Filter by Credit"
              value={filterData?.credit || ""}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, credit: e.target.value };
                });
                setCurrentFilterValue("credit");
                setCreditFilterDefaultOpen(true);
              }}
              endAdornment={filterData?.credit && (<IconButton
                size="small"
                onClick={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, credit: "" };
                  });
                  setCreditFilterData(null);
                }}
              >
                <X />
              </IconButton>)}
              open={creditFilterOpen}
              onClose={(e) => { setCreditFilterOpen(false); }}
              onOpen={(e) => setCreditFilterOpen(true)}
            >
              <MenuItem value="all">All Credit Scores</MenuItem>
              <MenuItem value="l_than">Below 650</MenuItem>
              <MenuItem value="g_than">650 & Above</MenuItem>
              <MenuItem value="custom" className={`${styles.customcredit}`} onClick={(e) => { setAddCustomCredit(true); setCreditFilterData(null); }}>
                {creditFilterData ? creditFilterData?.min + " - " + creditFilterData?.max : "Custom"}
              </MenuItem>
              {addCustomCredit && (<div className={`${styles.CustomFilterSec}`}>
                <form onSubmit={handleSubmit1(onSubmitCreditFiler)}>
                  <div className={`${styles.CustomFilterSecRow}`}>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`min`}
                        control={control1}
                        render={(field) => (<CreditScoreField
                          {...field}
                          id="outlined-basic"
                          label="Min Score"
                          variant="outlined"
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`max`}
                        control={control1}
                        render={(field) => (<CreditScoreField
                          {...field}
                          id="outlined-basic"
                          label="Max Score"
                          variant="outlined"
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrBUsec}`}>
                      <Button onClick={(e) => { setAddCustomCredit(false); setFilterData((prev) => { return { ...prev, credit: "" }; }); setCreditFilterData(null); setCreditFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                      <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                    </div>
                  </div>
                </form>
              </div>)}
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter CloseFilter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Filter by Salary</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Filter by Salary"
              value={filterData?.income || ""}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, income: e.target.value };
                });
                setCurrentFilterValue("income");
                setSalaryFilterDefaultOpen(true);
              }}
              endAdornment={filterData?.income && (<IconButton
                size="small"
                onClick={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, income: "" };
                  });
                  setSalaryFilterData(null);
                }}
              >
                <X />
              </IconButton>)}
              open={salaryFilterOpen}
              onClose={(e) => { setSalaryFilterOpen(false); }}
              onOpen={(e) => setSalaryFilterOpen(true)}
            >
              <MenuItem value="all">All Salary</MenuItem>
              <MenuItem value="b_20">&lt; $20,000</MenuItem>
              <MenuItem value="20_b_40">$20,000 - $40,000</MenuItem>
              <MenuItem value="40_b_60">$40,000 - $60,000</MenuItem>
              <MenuItem value="60_b_80">$60,000 - $80,000</MenuItem>
              <MenuItem value="a_80">&gt; $80,000</MenuItem>
              <MenuItem value="custom" className={`${styles.customcredit}`} onClick={(e) => { setAddCustomSalary(true); setSalaryFilterData(null); }}>
                {salaryFilterData ? "$" + salaryFilterData?.min + " - $" + salaryFilterData?.max : "Custom"}
              </MenuItem>
              {addCustomSalary && (<div className={`${styles.CustomFilterSec}`}>
                <form onSubmit={handleSubmit2(onSubmitSalaryFiler)}>
                  <div className={`${styles.CustomFilterSecRow}`}>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`min`}
                        control={control2}
                        render={(field) => (<MoneyField
                          {...field}
                          id="outlined-basic"
                          label="Min Salary"
                          variant="outlined"
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`max`}
                        control={control2}
                        render={(field) => (<MoneyField
                          {...field}
                          id="outlined-basic"
                          label="Max Salary"
                          variant="outlined"
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrBUsec}`}>
                      <Button onClick={(e) => { setAddCustomSalary(false); setFilterData((prev) => { return { ...prev, income: "" }; }); setSalaryFilterData(null); setSalaryFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                      <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                    </div>
                  </div>
                </form>
              </div>)}
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Follow-up Notes</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Follow-up Notes"
              value={filterData?.notes}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, notes: e.target.value };
                });
                setCurrentFilterValue("notes");
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="notes">Notes</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className={`${styles.ListGridBUCard} ${styles.Bottom}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("list")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>

      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}><Filter /></Link>

      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button className={`${styles.AddNoteBu} ${styles.Bottom}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
        <Plus /> <span>Prospect</span>
      </button>)}
    </div>
  </div>);
}

export default ListFilters;